import React, { useContext, useEffect, useRef, useState } from "react"
import { ApiCmnHeadersGetCall, ApiGetCall, ApiGetCDNData, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import { CamelCaseWithSpaces, CustomParseSafeHtml, formatDateToUsaMMDDYYYY, getTypeWatchDelay, LogInUserID, origin, shipStationUrlTrack, trackingHandle, transformNameOfCol, typewatch } from "../../JS/Common";
import Pagination from "react-js-pagination";
import { useNavigate, useLocation } from "react-router-dom";
import AlertsComp from "../../Components/AlertsComp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSatelliteDish } from "@fortawesome/free-solid-svg-icons";
import CustomizationPopup from "../../Components/CustomizationPopup";
import { Schoolsearchbar } from "../../Components/Schoolsearchbar";
import BatchDetailsPopup from "../../Components/BatchDetailsPopup";
import SignatureCanvas from "react-signature-canvas";
import jinja from "jinja-js";
import html2pdf from "html2pdf.js";
import PageHead from "../../Components/PageHead";
import Tab from "../../Components/Tab";
import AlertPopup from "../../Components/AlertPopup";
import { ThemeContext, UserContext } from "../../App";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";
import TrackingDetailsPopup from "../../Components/TrackingDetailsPopup";
import { useStickyAction } from "../../Hooks";

export function IncomingBatches() {
    const { origin_flag, school, adminCallNode } = useConfig();
    const { UserData } = useContext(UserContext);
    const { state } = useContext(ThemeContext);
    const navigate = useNavigate();
    const currentLocation = useLocation();
    const IncomingBatchStatus = currentLocation?.state?.IncomingBatchStatus;
    const [Batches, setBatches] = useState([]);
    const [SchoolID, setSchoolID] = useState([]);
    const [loading, setLoading] = useState(false);
    const [AttachTicketData, setAttachTicketData] = useState([]);
    const [BatchParams, setBatchParams] = useState({
        BatchTicketDataModal: false,
        BatchId: '',
        searchString: '',
        SortbyFlag: 'desc'
    });
    const [TabData, setTabData] = useState(() => {
        if (IncomingBatchStatus == 3) {
            return {
                OpenBatchesTab: '',
                CompletedBatchesTab: 'active'
            };
        }
        return {
            OpenBatchesTab: 'active',
            CompletedBatchesTab: ''
        };
    });
    const [ShowCreateBatchButton, setShowCreateBatchButton] = useState(false)
    const [AtVendorModal, setAtVendorModal] = useState(false)
    const [Alerts, setAlerts] = useState("");
    const [selectedIdsAll, setSelectedIdsAll] = useState([]);
    const [SelectedItems, setSelectedItems] = useState([]);
    const StateData = useSelector((state) => state.authData);
    const AdminSchoolId = StateData?.AdminSchoolId;
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const showPagination = Batches.length > 0;
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const SearchBatchName = pathArray[2];
    const sigCanvasForReceivedBy = useRef({});
    const [batchData, setBatchData] = useState({
        batchName: '',
        batchNote: ''
    })
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [SortKey, setSortKey] = useState(null)
    const [SignatureDataForReceivedBy, setSignatureDataForReceivedBy] = useState('');
    const initialTrackSate = {
        show: false,
        BatchId: null
    }
    const [showTrackingModal, setShowTrackingModal] = useState(initialTrackSate);
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const ExcludeVar = hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_VAR);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    useEffect(() => {
        ApiGetHeaders(30, setColumnNames, 1, AdminSchoolId)
    }, [AdminSchoolId]);
    useEffect(() => {
        setSchoolID(AdminSchoolId)
        if (AdminSchoolId != null && AdminSchoolId != undefined) {
            if (SearchBatchName != undefined) {
                setBatchParams({ ...BatchParams, searchString: SearchBatchName })
            }
            if (TabData.OpenBatchesTab == 'active') {
                AllBatches(AdminSchoolId, SearchBatchName ? SearchBatchName : null, SortKey || null, 1, false);
            } else {
                AllBatches(AdminSchoolId, SearchBatchName ? SearchBatchName : null, SortKey || null, 2, false);
            }
        }
    }, [AdminSchoolId, currentPage, LimitForPagination, SearchBatchName]);
    useEffect(() => {
        const selectedArray = [
            ...selectedIdsAll.map((id) => ({ id })),
        ];
        const idAndSubtotalArray = selectedArray.map(({ id }) => ({ id: id }));
        setSelectedItems(idAndSubtotalArray);
        if (idAndSubtotalArray.length === 0) {
            setShowCreateBatchButton(false)
        }
    }, [selectedIdsAll])
    async function AllBatches(schlid, searchString, SortKey, flag, toogleSort) {
        if (!searchString) searchString = null;
        if (SortKey && toogleSort) BatchParams.SortbyFlag = BatchParams.SortbyFlag == "asc" ? "desc" : "asc";
        var tabflag = null;
        if (flag == 1) {
            tabflag = 2
        } else {
            tabflag = 1
        }
        typewatch(async function () {
            setLoading(true)
            await ApiGetCall(`/schools/batches/all?schoolId=${schlid}&search=${searchString}&sortBy=${SortKey}&sortByOrder=${BatchParams.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&flag=${tabflag}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.total)
                    if (responseRs.data.length !== 0) {
                        var OpenBatches = null;
                        var CompletedBatches = null;
                        if (flag == 1) {
                            var OpenBatches = responseRs?.data
                        } else {
                            var CompletedBatches = responseRs?.data
                        }
                        if (SearchBatchName) {
                            const foundInOpenBatches = OpenBatches?.some(batch => {
                                const batchName = batch.batch_name.trim();
                                const searchStringTrimmed = searchString.trim();
                                return batchName && batchName.includes(searchStringTrimmed);
                            });
                            const foundInCompletedBatches = CompletedBatches?.some(batch => {
                                const batchName = batch.batch_name.trim();
                                const searchStringTrimmed = searchString.trim();
                                return batchName && batchName.includes(searchStringTrimmed);
                            });
                            if (foundInOpenBatches) {
                                setBatches(OpenBatches);
                                setTabData({ ...TabData, OpenBatchesTab: 'active', CompletedBatchesTab: '' });
                            } else if (foundInCompletedBatches) {
                                setBatches(CompletedBatches);
                                setTabData({ ...TabData, CompletedBatchesTab: 'active', OpenBatchesTab: '' });
                            } else {
                                setBatches([]);
                            }
                        } else {
                            if (flag === 1) {
                                setBatches(OpenBatches);
                                setTabData({ ...TabData, OpenBatchesTab: 'active', CompletedBatchesTab: '' });
                            } else {
                                setBatches(CompletedBatches);
                                setTabData({ ...TabData, CompletedBatchesTab: 'active', OpenBatchesTab: '' });
                            }
                        }
                    } else {
                        setBatches([]);
                    }
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }

    function handleSetSchoolId(id) {
        setSchoolID(id);
    }
    async function ShowTicketDataForBatch(batchId) {
        setLoading(true)
        setBatchParams({ ...BatchParams, BatchTicketDataModal: true, BatchId: batchId });
        await ApiGetCall(`/schools/batches/data-by-id?batchId=${batchId}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setBatchData({ ...batchData, batchName: responseRs?.batch_name, batchNote: responseRs?.batch_notes })
                if (responseRs.ticket.length != 0) {
                    setAttachTicketData(responseRs.ticket);
                } else {
                    setAttachTicketData([]);
                }
            }
        });
    }

    async function ExtraDocument(FedExQr) {
        ApiGetCDNData("/" + FedExQr, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    };

    function handleHeaderCheckboxChange(e, ticketFlag) {
        setShowCreateBatchButton(true);
        const isChecked = e.target.checked;
        if (ticketFlag === "all") {
            const currentPageIds = Batches.map((item) => item.id);
            if (isChecked) {
                setSelectedIdsAll(prev => [
                    ...prev.filter(id => !currentPageIds.includes(id)),
                    ...currentPageIds
                ]);
            } else {
                setSelectedIdsAll(prev => prev.filter(id => !currentPageIds.includes(id)));
            }
        }
    }

    function handleCheckboxChange(e, ticketFlag, ID) {
        const isChecked = e.target.checked;
        setShowCreateBatchButton(true)
        if (ticketFlag === "all") {
            setSelectedIdsAll((prevIds) => {
                if (isChecked) {
                    return [...prevIds, ID];
                } else {
                    return prevIds.filter((id) => id !== ID);
                }
            });
        }
    }
    async function AtVendorStatusChangeCall() {
        var signatureBase64 = null;
        signatureBase64 = sigCanvasForReceivedBy.current.isEmpty() ? null : sigCanvasForReceivedBy.current.getTrimmedCanvas().toDataURL("image/png");
        var raw = JSON.stringify({
            schoolId: SchoolID,
            batchIds: SelectedItems,
            userId: LogInUserID,
            receiverSignature: signatureBase64
        });
        setLoading(true)
        await ApiPostCall(`${adminCallNode}/batches/change-ticket-status`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setAtVendorModal(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Status Change Successfully"} />);
                    setTimeout(() => {
                        navigate('/school-tickets')
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const handleSortClick = (item) => {
        if (item == 'Total_Devices') {
            item = 'count'
        } else if (item == 'BatchName') {
            item = 'batch_name'
        } else {
            item = item.toLowerCase().split(' ').join('_');
        }
        if (item !== 0) {
            if (TabData.OpenBatchesTab == 'active') {
                AllBatches(SchoolID, BatchParams.searchString, item, 1, true)
            } else {
                AllBatches(SchoolID, BatchParams.searchString, item, 2, true)
            }
            setSortKey(item)
        }
    };
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "BatchName": <u className="cursor-pointer" title="Show Batch Details" onClick={(e) => ShowTicketDataForBatch(item.id)} batchid={item.id}>{item.batch_name}</u>,
            "Total_Devices": item.school_batch_log_count || '0',
            "TrackingNum": <span className='py-12 cursor-pointer' title="Track Shipment">
                {item.tracking_num != null ? <u title="Show Tracking Information" onClick={(e) => setShowTrackingModal(prev => ({ ...prev, show: true, BatchId: item?.id }))} batchid={item.id}>{item.tracking_num}</u> : <>-</>}
            </span>,
            "created_at": formatDateToUsaMMDDYYYY(item.created_at) || '-',
            "Notes": <div className="address">{item.notes || '-'}</div>,
        };
        return contentMap[columnName] || null;
    }
    const clearSignatureForReceivedBy = () => {
        if (SignatureDataForReceivedBy != null) {
            setSignatureDataForReceivedBy(null)
        } else {
            sigCanvasForReceivedBy.current.clear();
        }
    };
    function PrintPackingList(batchid) {
        setLoading(true)
        fetch(`${origin}/PackingList.html`)
            .then(response => response.text())
            .then(templateText => jinja.compile(templateText))
            .then(template => {
                ApiCmnHeadersGetCall(`/schools/batches/print-list?batchId=${batchid}`)
                    .then(response => JSON.parse(response))
                    .then(data => {
                        const formattedDate = new Date(data.createdAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        });
                        const rendered = template.render({ data, formattedDate });
                        const pdfContent = CustomParseSafeHtml(rendered, false);
                        pdfContent.style.padding = '20px';
                        html2pdf().from(pdfContent).save();
                        setLoading(false)
                    })
                    .catch(error => {
                        setLoading(false)
                        log.error('Error loading data from API', error);
                    });
            })
            .catch(error => {
                setLoading(false)
                log.error('Error loading template', error);
            });
    }
    function handleSearchChange(e) {
        if (TabData.OpenBatchesTab) {
            setCurrentPage(1);
            AllBatches(SchoolID, e.target.value, null, 1, true);
            setBatchParams({ ...BatchParams, searchString: e.target.value });
        } else {
            setCurrentPage(1);
            AllBatches(SchoolID, e.target.value, null, 2, true);
            setBatchParams({ ...BatchParams, searchString: e.target.value })
        }
        setBatchParams({ ...BatchParams, searchString: e.target.value });
        if (currentLocation.pathname.includes(SearchBatchName)) {
            navigate('/incoming-batches');
        }
    }
    function handleTabClick(tabType) {
        if (tabType == "open") {
            if (currentLocation.pathname.includes(SearchBatchName)) {
                navigate('/incoming-batches');
                setBatchParams({ ...BatchParams, searchString: '' });
            }
            setTabData({ ...TabData, OpenBatchesTab: 'active', CompletedBatchesTab: '' });
            setCurrentPage(1);
            AllBatches(SchoolID, null, null, 1, true);
        } else if (tabType == "completed") {
            if (currentLocation.pathname.includes(SearchBatchName)) {
                navigate('/incoming-batches');
                setBatchParams({ ...BatchParams, searchString: '' });
            }
            setTabData({ ...TabData, OpenBatchesTab: '', CompletedBatchesTab: 'active' });
            setCurrentPage(1);
            AllBatches(SchoolID, null, null, 2, true);
            setSelectedIdsAll([])
        }
    }
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Incoming Batches"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={AdminSchoolId || null} />
            <div className='row col-12 align-items-center pe-0 pt-2'>
                <div className="col-10">
                    <Schoolsearchbar setCurrentPage={setCurrentPage} schlid={handleSetSchoolId} setSelectedIdsAll={setSelectedIdsAll} GetGridData={AllBatches} flag={5} />
                </div>
            </div>
            <div className="GridBox p-3 mt-2">
                {AdminSchoolId && (
                    <div className="row align-items-center px-3">
                        <div className="col-xl-9 col-md-9 px-0">
                            <ul className="nav nav-tabs pb-3">
                                <Tab isActive={TabData.OpenBatchesTab == 'active'}
                                    label="Open Batches" onClick={() => handleTabClick('open')} col={'col-md-3'} />
                                <Tab isActive={TabData.CompletedBatchesTab == 'active'}
                                    label="Completed Batches" onClick={() => handleTabClick('completed')} col={'col-md-3'} />
                            </ul>
                        </div>
                        <div className="col-xl-3 text-end px-0">
                            {ExcludeVar &&
                                ShowCreateBatchButton == true && (
                                    <label className="BorderBtn ms-3 text-center mx-0" onClick={() => setAtVendorModal(true)}>
                                        <FontAwesomeIcon icon={faSatelliteDish} className="pe-2" />Receive
                                    </label>
                                )}
                        </div>
                    </div>
                )}
                <div className="greyBox p-3">
                    {AdminSchoolId ?
                        <div className="row px-3">
                            <div className="greyBox py-0">
                                <div className="data-table-container" ref={tableWrapperRef}>
                                    <table className="table data-table mb-0" >
                                        <thead className='GridHeader'>
                                            <tr>
                                                {ExcludeVar && Batches.length != 0 && TabData.OpenBatchesTab == 'active' && (
                                                    <th scope="col">
                                                        <input className='form-check-input' type="checkbox"
                                                            checked={Batches.length > 0 && Batches.every(item => selectedIdsAll.includes(item.id))}
                                                            onChange={(e) => handleHeaderCheckboxChange(e, "all")} />
                                                    </th>
                                                )}
                                                {columnNames?.map((item) => {
                                                    const columnName = item.replace(/_/g, ' ');
                                                    const transformedName = transformNameOfCol(columnName);
                                                    if (!transformedName) return null;
                                                    return (
                                                        <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                            {CamelCaseWithSpaces(transformedName)}
                                                            <img src="/images/sortbynew.svg" alt={`Sort by ${CamelCaseWithSpaces(transformedName)}`} className="img-fluid ps-2 sortbyClass" />
                                                        </th>
                                                    );
                                                })}
                                                <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>Action
                                                    <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Batches.length != 0 ?
                                                Batches.map((item, i) => {
                                                    return <tr key={i} className={`OddEvenClass tableBorderHide ${item.TicketFlag}`}>
                                                        {ExcludeVar && TabData.OpenBatchesTab == 'active' && (
                                                            <td className="py-12">
                                                                <input className='form-check-input' type="checkbox" checked={selectedIdsAll.includes(item.id)} onChange={(e) => handleCheckboxChange(e, "all", item.id)} batchid={item.id} />
                                                            </td>)}
                                                        {columnNames?.map(header => (
                                                            <td className="py-12" key={header}>
                                                                {renderContentForColumn(header, item)}
                                                            </td>
                                                        ))}
                                                        <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                            {item.shipstation_label ?
                                                                <img src="/images/previewpdficon.svg" className="cursor-pointer" title="Preview Shipping Document"
                                                                    onClick={(e) => ExtraDocument(item.shipstation_label)} style={{ height: '18px' }} batchid={item.id} />
                                                                : item?.label_url ?
                                                                    <img src="/images/previewpdficon.svg" className="cursor-pointer" title="Preview Shipping Document"
                                                                        onClick={(e) => shipStationUrlTrack(item?.label_url)} style={{ height: '18px' }} batchid={item.id} />
                                                                    : <>-</>
                                                            }
                                                            <img src="/images/printlabelicon.svg" title="Show Packing List" className="img-fluid cursor-pointer ps-2" onClick={(e) => PrintPackingList(item.id)} style={{ height: 18 }} />
                                                        </td>
                                                    </tr>
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={16} className="p-3 text-center">
                                                        No Record Found
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {showPagination && (
                                    <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                                        pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination} onChange={(e) => setCurrentPage(e)}
                                        color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                                        itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                                )}
                            </div>
                        </div>
                        :
                        <div className='text-center'>
                            <h1 className="PageHeading text-center mt-1" style={{ fontSize: "30px" }}>Please select {school} from the search box above to get going!</h1>
                            <img src="/images/setupplanicon.svg" className="img-fluid" style={{ height: '350px' }}></img>
                        </div>
                    }
                </div>
            </div>

            {BatchParams.BatchTicketDataModal == true && (
                <BatchDetailsPopup isShow={BatchParams.BatchTicketDataModal} ClosePopup={() => setBatchParams({ ...BatchParams, BatchTicketDataModal: false })} batchData1={batchData} AttachTicketData={AttachTicketData} />
            )}

            <AlertPopup isshow={AtVendorModal} img={'/images/greenInfo.svg'}
                headingtext={`Are you sure you want to mark all the tickets in this batch as 'At Vendor'?`}
                text={<div className="greyBox mt-4">
                    <div className='fw-600 font-15 text-center'>Received By Signature:</div>
                    <div className='mt-2 text-center'>
                        {SignatureDataForReceivedBy ? (
                            <img src={SignatureDataForReceivedBy} alt="Received By Signature" />
                        ) : (
                            <SignatureCanvas
                                ref={sigCanvasForReceivedBy}
                                canvasProps={{ width: 430, height: 100, className: "signatureCanvas" }}
                            />
                        )}
                    </div>
                    <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForReceivedBy}><u>Clear</u></label></div>
                </div>}
                cancelcall={(e) => { setAtVendorModal(false); setSelectedIdsAll([]) }}
                canceltext={"Cancel"} successtext={"Yes"} successcall={(e) => AtVendorStatusChangeCall(e)} btntype={'SaveBtn'} />
            {CustomizationModal == true && (
                <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={"Incoming Batches"} GetCall={() => ApiGetHeaders(30, setColumnNames, 1, StateData?.AdminSchoolId)} />
            )}
            {showTrackingModal.show && (
                <TrackingDetailsPopup showModal={showTrackingModal.show} closePopup={() => setShowTrackingModal(initialTrackSate)} BatchId={showTrackingModal.BatchId} />
            )}
        </React.Fragment>
    )
}
